export const DATE_FORMAT_DATETIME = 'dd-MM-yyyy, HH:mm';
export const DATE_FORMAT_DATE = 'dd-MM-yyyy';
export const DATE_FORMAT_PICKER = 'dd-MM-yyyy'; // date-fns tokens (renders identically to the old moment 'DD-MM-YYYY')

export const MOBILE_HEADER_HEIGHT = 85;
export const MAX_FORMULA_INT = 9223372036854775807;

// Must not exceed the API validation / column limits (scenario notes & control description 2048, impact 1024)
export const CHAR_LIMITS = {
  scenarioName: 255,
  scenarioNote: 10000,
  controlDescription: 2000,
  incidentDescription: 2000,
  incidentImpact: 1000,
  // CRPD-7287 (I02): raised 200 → 1000 at Jennifer's request. The BE already accepts far more
  // (`cost_note` is a `text` column; ContentImportService validates `max:2048`), so this cap is
  // FE-only. It MUST stay shared by the control form and BOTH cost CSV importers — a note typed
  // in the UI has to survive a CSV round-trip.
  costNote: 1000,
} as const;

/**
 * Maximum control rows accepted by the two cost CSV importers (framework / content editor, and
 * the RMP importer).
 *
 * Kept at 60 to MATCH THE API, which validates `'controls' => required|array|max:60`
 * (`ContentImportService`). CRPD-7287 (I03) raised this to 1000 at Jennifer's request, but the
 * raise was dropped because the FE cap must never exceed the BE one — a 61+ row file would then
 * trade a clean client-side message for a server 422. If the API cap is raised later, this single
 * constant is the only FE change needed.
 */
export const CSV_IMPORT_MAX_CONTROLS = 60;

export const charLimitError = (fieldName: string) => `You have entered too many characters in "${fieldName}"`;

export const MOTION_TRANSITION = { type: 'tween', duration: 0.2 };

export const isDev = process.env.NODE_ENV === 'development';
export const API_DEBUG = true;

const getEnvironment = (): 'development' | 'test' | 'staging' | 'production' => {
  if (isDev) {
    return 'development';
  }

  const url = window.location.origin.toLowerCase();

  if (url.includes('test.cydea')) {
    return 'test';
  }

  if (url.includes('staging.cydea')) {
    return 'staging';
  }

  return 'production';
};

export const env = getEnvironment();
